import { BLOCK_CLASSES as e } from "../../constants.js";
import { defineAttrs as t } from "../../utils/typed-attrs.js";
import { centerable as n } from "../decorators/centerable.js";
import { uploadable as r } from "../decorators/uploadable.js";
import "../decorators.js";
var i = n(r({
	inline: !1,
	draggable: !0,
	attrs: t({
		type: { default: "videoFile" },
		duration: { default: 0 },
		url: { default: "" },
		thumbnailUrl: { default: "" },
		captions: { default: "" }
	}),
	group: "block",
	parseDOM: [{
		tag: ".intercom-interblocks-video-file",
		getAttrs(e) {
			let t = e.querySelector("a"), n = e.querySelector("img");
			return {
				thumbnailUrl: n?.getAttribute("src") ?? "",
				url: t?.getAttribute("href") ?? "",
				captions: n?.getAttribute("alt") ?? ""
			};
		}
	}, {
		tag: ".embercom-prosemirror-composer-block-container.embercom-prosemirror-composer-video video",
		getAttrs(e) {
			let t = e.querySelector("source");
			return {
				thumbnailUrl: e.getAttribute("poster") ?? "",
				url: t?.getAttribute("src") ?? "",
				captions: t?.getAttribute("alt") ?? ""
			};
		}
	}],
	toDOM(t) {
		let n = t.attrs;
		return [
			"div",
			{ class: `${e.blockContainer} ${e.video}` },
			[
				"video",
				{
					class: "block-video-file-player",
					controls: "pause play mute",
					poster: n.thumbnailUrl,
					style: "display: block; width: 100%; height: 100%;"
				},
				["source", {
					src: n.url,
					alt: n.captions
				}]
			]
		];
	}
}));
//#endregion
export { i as videoFileSpec };
